// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import { Link, useParams } from 'react-router-dom';
import { Modal, Form, Button } from 'react-bootstrap';
import BlockUi from 'react-block-ui';
import MUIDataTable from "mui-datatables";
import SVG from "react-inlinesvg";
// CUSTOM COMPONENTS
// SERVICES AND HELPERS
import * as jobUploadFormService from '../../../../../../services/form/jobUploadFormService';
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
//STYLES AND ASSETS
import 'react-block-ui/style.css';

const OneTimeFormsListingTable = (props) => {
    const { oneTimeForms, showConfirmModal, auth, history, fetchOneTimeAndAsNeededForms, unsubmitForm, determineAndStartForm, determineAndSetFormAsNA } = props;
    const [showNAModal, setShowNAModal] = useState(false);
    const [oneTimeFormOnSpecificIndex, setOneTimeFormOnSpecificIndex] = useState({});
    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 15,
                download: false,
                setCellProps: () => ({ style: { width: "30%" } }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>

                            <button
                                // disabled={oneTimeForms[dataIndex].isNotApplicable}
                                className="btn btn-sm btn-primary font-weight-bold py-2 px-3 px-xxl-5 my-1"
                                onClick={() => {
                                    !oneTimeForms[dataIndex].isNotApplicable ?
                                        (oneTimeForms[dataIndex].status === 'Completed' ? determineAndStartForm({ ...oneTimeForms[dataIndex], frequency: "ONCE" }, false) :
                                            determineAndStartForm({ ...oneTimeForms[dataIndex], frequency: "ONCE" }, true)) :
                                        handleSetJobFormAsNA(dataIndex)
                                }}
                            >
                                {!oneTimeForms[dataIndex].isNotApplicable ? (oneTimeForms[dataIndex].status === "Completed" ? "View" : "Fill") : "View Reason"}
                            </button> &nbsp;
                            {
                                auth.isAdmin &&
                                <button
                                    disabled={oneTimeForms[dataIndex].isNotApplicable || (!auth.isAdmin && oneTimeForms[dataIndex].status === "Pending")}
                                    className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5 my-1"
                                    onClick={() => determineAndStartForm({ ...oneTimeForms[dataIndex], frequency: "ONCE" }, true)}
                                >
                                    {"Edit"}
                                </button>
                            }
                            &nbsp;
                            {
                                oneTimeForms[dataIndex].status !== "Completed" &&
                                <button
                                    disabled={oneTimeForms[dataIndex].isNotApplicable}
                                    onClick={() => {
                                        handleSetJobFormAsNA(dataIndex)
                                    }
                                        // showConfirmModal({
                                        //     title: "Mark N/A",
                                        //     text: "Are you sure you want to mark this form as N/A?  Once Marked N/A this form will not be accessible.",
                                        //     rightBtnText: "Confirm",
                                        //     btnAction: () => determineAndSetFormAsNA(oneTimeForms[dataIndex])
                                        // })
                                    }
                                    className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                                >
                                    N/A
                                </button>
                            }
                            &nbsp;
                            {
                                (auth.isAdmin || auth.isProjectManager) &&
                                <button
                                    disabled={(oneTimeForms[dataIndex].status !== 'Completed' || oneTimeForms[dataIndex].isNotApplicable) ? true : false}
                                    className="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
                                    onClick={() => {
                                        showConfirmModal({
                                            title: "Unsubmit Form",
                                            text: "Are you sure you want to unsubmit this form?",
                                            rightBtnText: "Confirm",
                                            btnAction: () => unsubmitForm(oneTimeForms[dataIndex].id)
                                        })
                                    }}
                                >
                                    {"Unsubmit"}
                                </button>
                            }
                            <Modal centered size="lg" show={showNAModal} onHide={() => {
                                handleModalClose()
                            }}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Are you sure you want to mark this form as N/A?  Once Marked N/A this form will not be accessible.</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {
                                        // oneTimeForms[dataIndex].reasonForNA ?
                                        //     <p>{oneTimeForms[dataIndex].reasonForNA}</p> :
                                        <div className="form-group row">
                                            <div className="col-lg-12 col-xl-12">
                                                <label>Please enter the reason for N/A selection in the text box below</label>
                                            </div>
                                            <div className="col-lg-12 col-xl-12">
                                                <div className="input-group input-group-lg input-group-solid">
                                                    <Form.Control as="textarea" rows="7"
                                                        placeholder="Enter N/A Reason"
                                                        className={`form-control form-control-lg form-control-solid`}
                                                        name="rejectionReason"
                                                        disabled={oneTimeFormOnSpecificIndex.isNotApplicable}
                                                        value={oneTimeFormOnSpecificIndex.reasonForNA}
                                                        onChange={e => {
                                                            setOneTimeFormOnSpecificIndex({ ...oneTimeFormOnSpecificIndex, reasonForNA: e.target.value });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => {
                                        handleModalClose();
                                    }}>
                                        Close
                                    </Button>
                                    {!oneTimeFormOnSpecificIndex.isNotApplicable && <button
                                        type="submit"
                                        className="btn btn-success mr-2"
                                        disabled={
                                            !oneTimeFormOnSpecificIndex.reasonForNA
                                        }
                                        onClick={() => {
                                            determineAndSetFormAsNA({ ...oneTimeFormOnSpecificIndex, frequency: "ONCE" });
                                            handleModalClose();
                                        }}
                                    >
                                        Confirm and Submit Reason
                                    </button>}
                                </Modal.Footer>
                            </Modal>
                        </>
                    );
                }
            },
        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "date",
            label: "Form Date",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "isNotApplicable",
            label: "N/A?",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({ style: { width: "5%" } }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <SVG
                                className="h-50 align-self-center"
                                src={toAbsoluteUrl(oneTimeForms[dataIndex].isNotApplicable ? "/media/svg/icons/Navigation/Check.svg" : "/media/svg/icons/Navigation/Close.svg")}
                            >
                            </SVG>
                        </>
                    );
                }
            }
        }
    ];

    const handleSetJobFormAsNA = (index) => {
        setShowNAModal(true);
        setOneTimeFormOnSpecificIndex({ ...oneTimeForms[index], frequency: 'ONCE' })
    }

    const handleModalClose = () => {
        setShowNAModal(false);
        setOneTimeFormOnSpecificIndex({})
    }

    return (
        <div className="mb-10">
            <MUIDataTable
                data={oneTimeForms}
                columns={columns}
                title="One Time Forms"
                options={{
                    rowsPerPage: 10,
                    selectableRows: 'none',
                }}
            />
        </div>
    )
}

export default OneTimeFormsListingTable;